export default __webpack_public_path__ + "static/media/africa.52ee1c0d.png";